import { render, staticRenderFns } from "./DiscountCode.vue?vue&type=template&id=f4254300&"
import script from "./DiscountCode.vue?vue&type=script&lang=ts&"
export * from "./DiscountCode.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports